import { Injectable, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import dayjs, { Dayjs } from 'dayjs';

@Injectable({
  providedIn: 'root'
})
export class DateRangeDisplayService {
  private datePipe: DatePipe = inject(DatePipe);


  dateRangeStr(
    startDayjs: Dayjs | undefined,
    endDayjs: Dayjs | undefined,
    {
      delimiter = `-`,
      adjustEndOneDay,
    }: {
      delimiter?: string;
      adjustEndOneDay?: boolean;
    } = {}
  ): string {
    let startFormat: string = 'mediumDate';
    let endFormat: string = 'mediumDate';
    let onlyFormat: string | undefined;
    let str: string = '';
    if (startDayjs && !endDayjs) {
      str = `${this.datePipe.transform(startDayjs.toDate(), startFormat)}`;
    } else if (!startDayjs && endDayjs) {
      str = `${this.datePipe.transform(endDayjs.toDate(), endFormat)}`;
    } else if (startDayjs && endDayjs) {
      let adjustedEndDayjs: Dayjs = endDayjs;
      if (
        adjustEndOneDay
      ) {
        adjustedEndDayjs = endDayjs.subtract(1, 'day');
      }
      if (
        startDayjs.get('year') === endDayjs.get('year')
      ) {
        let yearFormat: string = `, y`;
        if (startDayjs.get('year') === dayjs().get('year')) {
          yearFormat = '';
        }
        if (
          startDayjs.get('month') === endDayjs.get('month')
        ) {
          if (
            startDayjs.get('date') === endDayjs.get('date')
          ) {
            onlyFormat = `MMM d${yearFormat}`;
          } else {
            startFormat = `MMM d`;
            endFormat = `d${yearFormat}`;
          }
        } else {
          startFormat = `MMM d`;
          endFormat = `MMM d${yearFormat}`;
        }
      } else {
        startFormat = `MMM d, y`;
        endFormat = startFormat;
      }
      if (onlyFormat) {
        str = `${this.datePipe.transform(startDayjs.toDate(), onlyFormat)}`;
      } else {
        str = `${this.datePipe.transform(startDayjs.toDate(), startFormat)} ${delimiter} ${this.datePipe.transform(adjustedEndDayjs.toDate(), endFormat)}`;
      }
    }
    return str;
  }
}
